import { useMutation } from 'react-query'

import { request } from '../../global/api/legacyApi'
import { HTTPMethod } from '../utils/api.types'
import type { APIResponse } from '../utils/api.types'

type UpdateSpeakerRequest = {
  live_speaker_id: number
  request_status: RequestStatus
}

type UpdateSpeakerResponse = APIResponse

type RequestStatus = 'requested' | 'approved' | 'denied' | 'expired'

type UpdateSpeakerParams = {
  speakerId: number
  requestStatus: RequestStatus
}

function updateSpeaker(params: UpdateSpeakerParams) {
  return request<UpdateSpeakerResponse>({
    url: '/api/2/live/speaker/update',
    method: HTTPMethod.POST,
    data: {
      live_speaker_id: params.speakerId,
      request_status: params.requestStatus,
    } satisfies UpdateSpeakerRequest,
  })
}

function useUpdateSpeakerMutation() {
  return useMutation(updateSpeaker)
}

export { updateSpeaker, useUpdateSpeakerMutation }
